import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const HelpEconomicallyChllngedPatients = () => {
  return (
    <>
      <Helmet>
        <title>
          Donate for Cancer Treatment at TATA memorial, Cancer Charity NGO
        </title>

        <meta
          name="description"
          content="Cancer patients and their families undergo physical, emotional, mental trauma and could also get devastated financially. Donate now and give cancer patients the financial relief they need."
        />
        <meta name="robots" content="index,nofollow,noodp" />
        <link
          rel="canonical"
          href="https://www.copewithcancer.org/financial-aid-at-tata-memorial"
        />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Donate for Cancer Treatment at TATA memorial, Cancer Charity NGO"
        />
        <meta
          property="og:description"
          content="Cancer patients and their families undergo physical, emotional, mental trauma and could also get devastated financially. Donate now and give cancer patients the financial relief they need."
        />
        <meta
          property="og:url"
          content="https://www.copewithcancer.org/financial-aid-at-tata-memorial"
        />
        <meta property="og:site_name" content="Cope with Cancer" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/copewithcancer/"
        />
        <meta property="article:section" content="our-causes" />
        <meta
          property="og:image"
          content="https://cwc-react.s3.ap-south-1.amazonaws.com/img/home/finacial_aid_banner-2.jpg"
        />
        <meta
          property="og:image"
          content="https://cwc-react.s3.ap-south-1.amazonaws.com/img/home/tata-hospital-logo.jpg"
        />
        <meta property="og:image:width" content="1366" />
        <meta property="og:image:height" content="270" />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:description"
          content="Cancer patients and their families undergo physical, emotional, mental trauma and could also get devastated financially. Donate now and give cancer patients the financial relief they need."
        />
        <meta
          name="twitter:title"
          content="Donate for Cancer Treatment at TATA memorial, Cancer Charity NGO"
        />
        <meta name="twitter:site" content="@copewithcancer" />
        <meta
          name="twitter:image"
          content="https://cwc-react.s3.ap-south-1.amazonaws.com/img/home/finacial_aid_banner-2.jpg"
        />
        <meta name="twitter:creator" content="@copewithcancer" />
        <meta property="DC.date.issued" content="2016-05-05T14:57:33+00:00" />
      </Helmet>

      <div className="topspace">
        <article>
          <div className="text-center">
            <div className="financialaidbanner"><div className="bannertitleNew1">Financial Aid to Economically
              <br /> Challenged Patients</div></div>
            {/* <img
              src={financial_aid_banner}
              alt="What is Cancer"
              className="w-100 w100"
            ></img> */}
            <h1 class="bannertitle displayNone">
              Financial Aid to Economically
              <br /> Challenged Patients
            </h1>
          </div>
          <div className="contentBox">
            <div className="container">
              <div className="row">
                <div className="col-md-8">
                  <p className="displayNone">FINANCIAL AID</p>

                  <p>
                    It is known that for best results, cancer needs to be
                    treated immediately when detected, before it spreads more
                    than it already has. Cancer patients and their families
                    undergo physical, emotional andamp; mental trauma and could
                    also get devastated financially.
                  </p>
                  <h4 className="Bold16 mb15 tata-section-mobile-top">
                    Helping economically challenged cancer patients at Tata Memorial Hospital Mumbai and affiliated hospitals
                  </h4>
                  <p>
                    Economically challenged patients registered in General
                    category In Tata Hospital Mumbai (TMH) andamp; Actrec, HBCH
                    Varanasi andamp; HBCH Vizag are provided financial support for
                    diagnostic investigations, chemotherapy, radiation therapy,
                    surgery, procedures andamp; ICU support.
                  </p>
                  <p>
                    The MSW team (Medical Social worker) emails the list of
                    patients needing funds after reviewing their TMH Trust
                    accounts.
                  </p>
                  <p>
                    After checking the documents andamp; the fund gap, funds
                    enough for the immediate treatment scheduled for the coming
                    week are digitally transferred to the patient's Trust
                    account in TMH
                  </p>
                  <p>
                    The funds are deployed exactly when they are needed and used
                    for what they were sanctioned for.
                  </p>
                  <div className="tataContentBox mb20 mt20">
                    <div className="row">
                      <div className="col-md-3">
                        <img src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/home/tata-hospital-logo.jpg" alt="tata-hospital-logo"></img>
                      </div>
                      <div className="col-md-9 p40">
                        <p>
                          <a className="urlLinkRgular Bold16" href="/campaigns/help-economically-challenged-cancer-patients">
                            Appreciation Letter from Tata Memorial Hospital
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                  <p className="Bold14">
                    Funds used in Tata Memorial Hospital 
                    {/* – (Updated 2025-26) */}
                  </p>
                  <style>{`
                    .stat-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 0; margin-bottom: 20px; }
                    .stat-card { display: flex; flex-direction: column; }
                    .stat-num1 { background: #A05B8A; color: #fff; font-size: 34px; font-family: 'poppinsmedium'; padding: 20px 10px 0; text-align: center; }
                    .stat-num2 { background: #965BA0; color: #fff; font-size: 34px; font-family: 'poppinsmedium'; padding: 20px 10px 0; text-align: center; }
                    .stat-num3 { background: #5BA09C; color: #fff; font-size: 34px; font-family: 'poppinsmedium'; padding: 20px 10px 0; text-align: center; }
                    .stat-num4 { background: #5CA05B; color: #fff; font-size: 34px; font-family: 'poppinsmedium'; padding: 20px 10px 0; text-align: center; }
                    .stat-lbl1 { background: #A05B8A; color: #fff; font-size: 13px; padding: 0 20px 20px; text-align: center; flex: 1; }
                    .stat-lbl2 { background: #965BA0; color: #fff; font-size: 13px; padding: 0 20px 20px; text-align: center; flex: 1; }
                    .stat-lbl3 { background: #5BA09C; color: #fff; font-size: 13px; padding: 0 20px 20px; text-align: center; flex: 1; }
                    .stat-lbl4 { background: #5CA05B; color: #fff; font-size: 13px; padding: 0 20px 20px; text-align: center; flex: 1; }
                    @media (max-width: 767px) {
                      .stat-grid { grid-template-columns: 1fr; }
                      .stat-card { flex-direction: row; align-items: stretch; }
                      .stat-num1, .stat-num2, .stat-num3, .stat-num4 { min-width: 100px; font-size: 24px; padding: 16px 10px; display: flex; align-items: center; justify-content: center; }
                      .stat-lbl1, .stat-lbl2, .stat-lbl3, .stat-lbl4 { text-align: left; padding: 16px 14px; display: flex; align-items: center; }
                    }
                  `}</style>
                  <div className="stat-grid mb20">
                    {[
                      { num: "32.8%", lbl: "Chemotherapy", n: "stat-num1", l: "stat-lbl1" },
                      { num: "48.7%", lbl: "Surgery", n: "stat-num2", l: "stat-lbl2" },
                      { num: "0.02%", lbl: "Radiation Therapy", n: "stat-num3", l: "stat-lbl3" },
                      { num: "18.48%", lbl: "Investigations and Supportive Care", n: "stat-num4", l: "stat-lbl4" },
                    ].map((s, i) => (
                      <div className="stat-card" key={i}>
                        <div className={s.n}>{s.num}</div>
                        <div className={s.l}>{s.lbl}</div>
                      </div>
                    ))}
                  </div>

                  <p className="Bold14">
                  Funds used in Private Charitable Hospitals pan India 
                  {/* – (Updated 2025-26) */}
                  </p>
                  <div className="stat-grid mb20" style={{ marginBottom: "30px" }}>
                    {[
                      { num: "12%", lbl: "Chemotherapy", n: "stat-num1", l: "stat-lbl1" },
                      { num: "59.2%", lbl: "Surgery", n: "stat-num2", l: "stat-lbl2" },
                      { num: "26.6%", lbl: "Radiation Therapy", n: "stat-num3", l: "stat-lbl3" },
                      { num: "2.2%", lbl: "Investigations and Supportive Care", n: "stat-num4", l: "stat-lbl4" },
                    ].map((s, i) => (
                      <div className="stat-card" key={i}>
                        <div className={s.n}>{s.num}</div>
                        <div className={s.l}>{s.lbl}</div>
                      </div>
                    ))}
                  </div>

                  <div className="row mt20 mb10">
                    {[
                      { src: "financial-aid-img-1.png", caption: "Education Grant to a Cancer Victor" },
                      { src: "financial-aid-img-2.png", caption: "First Formal Wig Donation" },
                      { src: "financial-aid-img-3.png", caption: "Limb Prosthesis Donated to a Patient" },
                      { src: "financial-aid-img-4.png", caption: "Photo Booth at Christmas Party at Tata Hospital" },
                      { src: "financial-aid-img-5.png", caption: "Post Breast Surgery Counselling" },
                      { src: "financial-aid-img-6.png", caption: "Kids At our Supercar Rally" },
                      { src: "financial-aid-img-7.png", caption: "Music Program for Patients and Caregivers" },
                      { src: "financial-aid-img-8.png", caption: "Music Program for Patients and Caregivers at Actrec" },
                      { src: "financial-aid-img-9.png", caption: "Photo Booth at Tata Hospital" },
                    ].map((img, i) => (
                      <div className="col-md-4 mb30" key={i}>
                        <div className="imgFixbox1">
                          <img
                            src={`https://cwc-react.s3.ap-south-1.amazonaws.com/img/${img.src}`}
                            alt={img.caption}
                            className="w-100 mb20"
                            style={{ height: "200px", objectFit: "cover" }}
                          />
                          <p className="medium14 mb0">{img.caption}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <p className="Bold14">
                    Helping economically challenged cancer patients at other
                    cancer hospitals pan india
                  </p>
                  <p>
                    Treatment for cancer may get delayed as the Government and
                    good low-cost facilities are limited. Patients may take
                    loans to get the treatment done at private hospitals where
                    the cost is higher and as a result end up carrying a huge
                    unmanageable debt and push their families to penury. Often,
                    because of lack of funds and difficulty in raising
                    sufficient funds, the treatment is delayed or not just
                    taken.
                  </p>
                  <p>
                    We work with private hospitals and doctors to address this
                    need. For our project, they discount their treatment rates
                    substantially for the economically challenged patients.
                  </p>
                  <p>
                    Target beneficiaries are the General Category Patients from
                    hospitals all over India whose cancer surgery, chemotherapy
                    andamp; radiation therapy treatment is getting delayed due to
                    unavailable appointments because of the overload at the
                    hospitals or lack of funds. By offering financial support,
                    we have realised that the patient does not drop out from
                    completing the treatment due to financial reasons.
                  </p>
                  <p>
                    Doctors / hospitals apply for funding for financially
                    challenged patients to MCT, offering a lower discounted cost
                    than routine General ward charges.
                    <br />
                    Cost estimate andamp; other documents of the patients are
                    thoroughly screened by the CEO andamp; senior team before
                    sanctioning an amount.
                    <br />A Letter of Approval conveying the sanctioned amount
                    is emailed to the hospital.
                  </p>
                  <p>
                    The patient pays the balance amount to the hospital for
                    initiating the treatment which could be self generated or
                    through other NGOs.
                    <br />
                    The approved amount is digitally transferred to the hospital
                    after the completion of the approved treatment.
                  </p>
                  {/* <p className="Bold14">
                    Funds used in Tata Memorial Hospital –
                  </p>
                  <table className="mb20 table-responsive">
                    <tbody>
                      <tr>
                        <td className="tableNumber1">23%</td>
                        <td className="tableNumber2">6%</td>
                        <td className="tableNumber3">69%</td>
                        <td className="tableNumber4">2%</td>
                      </tr>
                      <tr>
                        <td className="tableHeading1">Radiation Therapy</td>
                        <td className="tableHeading2">Chemotherapy</td>
                        <td className="tableHeading3">Surgery</td>
                        <td className="tableHeading4">Other Procedures</td>
                      </tr>
                    </tbody>
                  </table> */}

                  <p className="displayNone">andnbsp;</p>
                  <p>
                    <span>
                      Current Status: Project operational since 2018. Cities
                      where services are provided are Mumbai, Navi Mumbai,
                      Panvel, Nashik, Pune, Kanpur, Varanasi, Kolkata and
                      Coimbatore.{" "}
                    </span>
                    Funds deployed per patient vary from Rs 10000 to 130000
                    depending on the requirement andamp; our assessment.
                  </p>
                  <p className="Bold14">
                    <span>
                      <strong>
                        Please note that 95% of the donation received is used
                        for patient treatment.{" "}
                      </strong>
                    </span>
                  </p>
                  <p className="Bold14">
                    <span>
                      <strong>
                        <span lang="EN-US">
                          Madat Trust is registered with the Charity
                          Commissioner and has an 80G exemption certificate
                        </span>
                      </strong>
                    </span>
                  </p>
                  <p className="BoldColor14">Madat Charitable Trust</p>
                  <p className="RegularColor14">
                    <b>Account No:</b> 109801001425
                  </p>
                  <p className="RegularColor14">
                    <b>Bank Name:</b> ICICI Bank
                  </p>
                  <p className="RegularColor14">
                    <b>RTGS/NEFT IFSC Code:</b> ICIC0001098
                  </p>
                  <p className="RegularColor14">
                    <b>MICR:</b> 400229114
                  </p>
              
                  {/* <div className="Bold14">
                    <strong>
                      We shall email the digital 80G certificate receipt to you
                      within 2 weeks.
                    </strong>
                  </div> */}
                   <div className="Bold14">
                    <strong>

It is mandatory by law to issue an 80G receipt and 10BE certificate for every donation we receive.
Request you to email a copy of the pan card, the individual/ company address and mobile number at <a
                        className="urlLinkRgular"
                        href="mailto:somavathy@copewithcancer.org"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        somavathy@copewithcancer.org
                      </a> & <a href="mailto:support@copewithcancer.org" class="urlLinkRgular">support@copewithcancer.org</a>  for generating 80G receipt and 10BE certificate for the donation made.



                    {/* It is mandatory by law to issue an 80G receipt and 10BE certificate for every donation we receive. Request you to email the individual/ company address and mobile number at <a
                        className="urlLinkRgular"
                        href="mailto:support@copewithcancer.org"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        somavathy@copewithcancer.org
                      </a> for an 80G and 10BE certificate and receipt for the donation made.  */}
                    </strong>
                  </div>
                  <div className="mobile-80g-space"></div>
                      {/* <div className="Bold14">
                    <strong>
                      Request you to email a copy of the PAN card to{" "}
                      <a
                        className="urlLinkRgular"
                        href="mailto:support@copewithcancer.org"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        somavathy@copewithcancer.org
                      </a>
                    </strong>
                  </div> */}
                </div>
                <div className="col-md-4">
                  <div className="tataContentBoxGray">
                    <img src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/home/tata-hospital-logo.jpg" alt="tata-hospital-logo" className="mb15"></img>
                    <h3 className="semibold16 mb15">
                      Helping Economically Challenged Cancer Patients at Tata
                      Memorial Hospital
                    </h3>
                    <h2 className="Bold14 mb15">
                      Your donation will help to...
                    </h2>
                    <div className="flex">
                      <p className="pm mb10">
                        {" "}<i class="fa-solid fa-arrow-right mr5 iIconRight"></i>
                        Support our current activities at Tata Memorial Hospital.
                      </p>
                    </div>
                    <div className="flex">
                      <p className="pm mb10">
                        {" "}<i class="fa-solid fa-arrow-right mr5 iIconRight"></i>{" "}
                        Support our current activities and allow us to address other economically challenged categories at Tata Memorial Hospital.
                      </p>
                    </div>
                    <div className="flex mb20">
                      <p className="pm mb0">
                        {" "}<i class="fa-solid fa-arrow-right mr5 iIconRight"></i>{" "}
                        Fund medical services that can be delivered at government and private hospitals at special discounted rates.
                      </p>
                    </div>
                    <form className="form-inline my-2 my-lg-0">
                      <Link
                        className="animate__animated animate__shakeX animate__delay-2s btn btn-primary my-2 my-sm-0 Allbtn"
                        to="https://pages.razorpay.com/pl_G7hEXf8amXUXcG/view"
                        onClick={() => { }}
                        href=""
                      >
                        Donate Now
                      </Link>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>

        {/* ── How It Works ── */}
        <HowItWorksSection />

        {/* ── FAQ Accordion ── */}
        <FAQSection />

    </>
  );
};

const hiw_steps = [
  { icon: "fa-paper-plane", label: "Submit Enquiry" },
  { icon: "fa-magnifying-glass", label: "Initial Review" },
  { icon: "fa-phone-volume", label: "Team Contacts Applicant" },
  { icon: "fa-file-circle-check", label: "Eligibility & Document Verification" },
  { icon: "fa-hand-holding-heart", label: <>Approval Letter is Given<br />(If Eligible)</> },
];

const HowItWorksSection = () => (
  <>
    <style>{`
      .fa-hiw-stepper { display: flex; align-items: flex-start; justify-content: center; position: relative; padding: 10px 0 30px; }
      .fa-hiw-stepper::before { content: ""; position: absolute; top: 41px; left: 10%; right: 10%; height: 3px; background: #A05B8A; border-radius: 2px; z-index: 0; }
      .fa-hiw-step { flex: 1; display: flex; flex-direction: column; align-items: center; text-align: center; position: relative; z-index: 1; padding: 0 8px; }
      .fa-hiw-circle { width: 64px; height: 64px; border-radius: 50%; background: #A05B8A; display: flex; align-items: center; justify-content: center; margin-bottom: 14px; flex-shrink: 0; }
      .fa-hiw-circle i { color: #fff; font-size: 22px; }
      .fa-hiw-label { font-size: 14px; font-weight: 700; color: #222; line-height: 1.4; }
      @media (max-width: 991px) {
        .fa-hiw-stepper::before { top: 28px; }
        .fa-hiw-circle { width: 56px; height: 56px; }
        .fa-hiw-circle i { font-size: 19px; }
        .fa-hiw-label { font-size: 14px; }
      }
      @media (max-width: 767px) {
        .hiw-after-approval { margin-top: 40px; }
        .tata-section-mobile-top { margin-top: 20px; }
        .mobile-80g-space { height: 20px; }
        .fa-hiw-stepper { flex-direction: column; align-items: stretch; padding: 0; }
        .fa-hiw-stepper::before { top: 24px; bottom: 24px; left: 24px; right: auto; width: 3px; height: auto; background: #A05B8A; }
        .fa-hiw-step { flex-direction: row; align-items: center; text-align: left; margin-bottom: 24px; padding: 0; gap: 16px; }
        .fa-hiw-step:last-child { margin-bottom: 0; }
        .fa-hiw-circle { width: 48px; height: 48px; margin-bottom: 0; flex-shrink: 0; }
        .fa-hiw-circle i { font-size: 17px; }
        .fa-hiw-label { font-size: 14px; }
      }
    `}</style>
    <div style={{ background: "#EEF4F6", padding: "60px 0" }}>
      <div className="container">
        <h2 className="Bold28 mb10">How It Works</h2>
        <p className="Regular14 mb40" style={{ color: "#666" }}>Our simple five-step process to help you receive financial assistance.</p>
        <div className="fa-hiw-stepper">
          {hiw_steps.map((step, i) => (
            <div className="fa-hiw-step" key={i}>
              <div style={{ position: "relative" }}>
                <div className="fa-hiw-circle">
                  <i className={`fa-solid ${step.icon}`}></i>
                </div>
              </div>
              <div>
                <div className="fa-hiw-label">{step.label}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="hiw-after-approval" style={{ background: "linear-gradient(135deg, rgb(255, 255, 255), rgb(255, 255, 255))", border: "1.5px solid rgb(215, 215, 215)", borderRadius: "12px", padding: "24px 28px" }}>
          <p className="Bold16 mb15" style={{ color: "#333", fontSize:"16px" }}>
          
            What Happens After Approval
          </p>
          <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "flex", flexDirection: "column", gap: "10px" }}>
            {[
              <>Approval letter is given <strong>(If Eligible)</strong></>,
              "Once treatment is completed, the hospital sends us the bill",
              "Our audit team gets in touch with the relative",
              "Once the audit team confirms the details, payment is released",
              "Payment is transferred to the hospital within 48 hrs of our receiving the final bill",
            ].map((point, i) => (
              <li key={i} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                <i className="fa-solid fa-circle-check" style={{ color: "#A05B8A", fontSize: "15px", marginTop: "3px", flexShrink: 0 }}></i>
                <span className="Regular14" style={{ color: "#444", lineHeight: "1.6" }}>{point}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </>
);

const faqs = [
  { q: "Who can apply for financial assistance?", a: "Anyone who is economically challenged can apply. Assistance is only offered if the patient approaches us before the treatment starts. We cannot consider any application for funding once treatment has already started (except at Tata Hospital & Actrec)." },
  { q: "Cancer treatments covered.", a: "Surgery, Chemotherapy, Radiation Therapy, supportive ICU care, investigations like CT, MRI and Pet scans." },
  { q: "Types of financial assistance available.", a: "We can help the patients get discounted investigations and treatment at partner medical centers. In some cases we can also provide part funding for the investigation or treatment." },
  { q: "Applications are reviewed individually.", a: "Yes. Our audit team checks the applications, documents are asked for. Those which pass the initial evaluation are interviewed on phone and their answers noted down. These are then approved by senior members of the team and if all is okay, an approval letter is sent to the treating hospital." },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);
  return (
    <>
      <style>{`
        .faq-cols { display: flex; gap: 10px; align-items: flex-start; }
        @media (max-width: 767px) { .faq-cols { flex-direction: column; } }
      `}</style>
      <div style={{ background: "#fff", padding: "50px 0" }}>
        <div className="container">
          <h2 className="Bold28 mb30">Frequently Asked Questions Regarding Financial Aid</h2>
          <div className="faq-cols">
            {[faqs.filter((_, i) => i % 2 === 0), faqs.filter((_, i) => i % 2 !== 0)].map((col, colIdx) => (
              <div key={colIdx} style={{ flex: 1, display: "flex", flexDirection: "column", gap: "10px" }}>
                {col.map((faq) => {
                  const i = faqs.indexOf(faq);
                  return (
                    <div key={i} style={{ background: "#fff", borderRadius: "8px", border: openIndex === i ? "1.5px solid #D42A9E" : "1.5px solid #ecdff0", overflow: "hidden" }}>
                      <button
                        onClick={() => toggle(i)}
                        style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px", background: "none", border: "none", cursor: "pointer", textAlign: "left", outline: "none" }}
                      >
                        <span className="Bold14" style={{ color: "#333" }}>{faq.q}</span>
                        <i className={`fa-solid ${openIndex === i ? "fa-chevron-up" : "fa-chevron-down"}`} style={{ color: "#D42A9E", fontSize: "14px", flexShrink: 0, marginLeft: "12px" }}></i>
                      </button>
                      {openIndex === i && (
                        <div style={{ padding: "0 20px 16px 20px" }}>
                          <p className="Regular14 mb0" style={{ color: "#555", lineHeight: "1.7" }}>{faq.a}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
          <div style={{ background: "linear-gradient(135deg, rgb(247 247 247), rgb(237 237 237))", border: "1.5px solid rgb(219 219 219)", borderRadius: "12px", padding: "10px", marginTop: "30px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "16px" }}>
            <p className="Regular16 mb0" style={{ color: "#333", fontSize: "15px", fontWeight: 600 }}>
              Please contact us to submit your request for financial aid.
            </p>
            <Link to="/contact-us" className="btn btn-primary my-2 my-sm-0 Allbtn" style={{ flexShrink: 0 }}>
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default HelpEconomicallyChllngedPatients;
